<script lang="ts">
    import type { WokaData } from "./WokaTypes";
    import WokaImage from "./WokaImage.svelte";

    interface Props {
        selectedTextures: Record<string, string>;
        wokaData: WokaData | null;
        getTextureUrl: (url: string) => string;
        onrotate?: (direction: number) => void;
        ariaLabel?: string;
    }

    let {
        selectedTextures,
        wokaData = null,
        getTextureUrl = (url) => url,
        onrotate,
        ariaLabel = "Предпросмотр аватара",
    }: Props = $props();

    // Directions correspond to the order of images in the sprite sheet:
    const directionsMapping = [0, 1, 3, 2];

    let direction: number = $state(0);
    const canvasSize = 100;
    const canvasSizeHeight = canvasSize * 2.5;
</script>

<div class="woka-preview flex items-center justify-center relative">
    <div class="p-2 sm:p-6 relative flex items-center justify-center w-fit bg-white rounded-lg">
        <button
            class="hover:bg-mdark/5 rounded absolute bottom-2 right-2 aspect-square w-8 h-8 flex items-center justify-center border border-mblue-lighter border-solid"
            onclick={() => {
                direction = (direction + 1) % 4;
                onrotate?.(directionsMapping[direction]);
            }}
            aria-label="Повернуть"
        >
            <svg
                width="19"
                height="13"
                viewBox="0 0 19 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icons-tabler-outline icon-tabler-reload"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.93862 0.0347538C5.62504 0.181115 3.35271 0.849776 1.91487 1.80728C1.08452 2.36029 0.429123 3.11313 0.138317 3.84806C0.014551 4.1609 0.00128683 4.25693 7.63986e-05 4.84974C-0.00113403 5.44643 0.010718 5.53383 0.131862 5.82206C0.360834 6.36666 0.588748 6.70114 1.03292 7.14446C2.07722 8.18679 3.66525 8.92969 5.77291 9.36186C6.53674 9.51851 7.76507 9.66623 8.30371 9.66623H8.61822L7.85122 10.439C7.09303 11.2029 7.05254 11.2614 7.07634 11.5575C7.1067 11.935 7.56919 12.1555 7.93151 11.9651C8.0064 11.9257 8.62629 11.33 9.30903 10.6412C10.6075 9.33125 10.6509 9.27224 10.5594 8.94104C10.4948 8.70707 7.97503 6.209 7.75771 6.1634C7.44658 6.09814 7.1064 6.33735 7.07967 6.64016C7.05178 6.95553 7.08562 7.00622 7.82812 7.76223L8.57203 8.51965L8.01725 8.48561C5.37766 8.32357 3.05182 7.51071 1.88502 6.3425C1.29841 5.75519 1.16037 5.47119 1.15906 4.84898C1.15825 4.43451 1.17303 4.36405 1.3266 4.05186C1.6457 3.40307 2.38855 2.78913 3.47814 2.27359C7.20051 0.512369 13.342 0.914281 15.9836 3.09194C17.8713 4.6482 17.0369 6.53011 13.9315 7.72012C13.3577 7.94001 13.2372 8.05656 13.2372 8.392C13.2372 8.58088 13.2649 8.64488 13.4087 8.78867C13.6331 9.01306 13.7991 9.01174 14.4055 8.78086C15.5462 8.34641 16.4179 7.80954 17.0955 7.12403C17.8444 6.36635 18.1503 5.70596 18.149 4.84974C18.1471 3.6728 17.4714 2.64262 16.1227 1.76042C14.1874 0.494515 11.068 -0.163252 7.93862 0.0347538Z"
                    fill="#5F6FFF"
                />
            </svg>
        </button>
        <WokaImage
            {selectedTextures}
            {wokaData}
            {getTextureUrl}
            {canvasSize}
            {canvasSizeHeight}
            {ariaLabel}
            direction={directionsMapping[direction]}
        />
    </div>
</div>
